import components from 'components';
import CONSTS from 'consts';
import design from 'design';
import hooks from 'hooks';
import services from 'services';

export default () => {
    const application = hooks.useApplication();
    const component = hooks.useComponent({
        name: 'ExamTemplatesListView',
        async: {
            get: async () => {
                const response = await services.examTemplates.list();
                if(response.success) {
                    return response.payload;
                }
            }
        }
    });

    return (<>
        <design.components.section.Title
            text="Lista de plantillas"
            buttons={[
                <design.components.form.Button 
                    type="submit" 
                    icon="pi pi-plus"
                    label={CONSTS.MENU.EXAM.TEMPLATE.CREATE.LABEL}
                    onClick={() => {
                        application.navigate(CONSTS.MENU.EXAM.TEMPLATE.CREATE.PATH);
                    }}
                />
            ]}
        />
        <components.ExamTemplatesList
            isLoading={component.async.get.status === 'loading'}
            examTemplates={component.async.get.data?.examTemplates}
            onRowSelect={({ data: examTemplate }) => {
                const { id } = examTemplate;
                application.navigate(CONSTS.MENU.EXAM.TEMPLATE.DETAILS.PATH, { id });
            }}
        />
    </>)
};
